import { Component, OnInit, ChangeDetectionStrategy } from "@angular/core";

import { BaseComponent, UserService, HelperService, WindowService, environment } from "@mypxplat/xplat/core";
import { Router, ActivatedRoute } from "@angular/router";
import { AppService, AvoService, WebCommunityService } from "@mypxplat/xplat/web/core";
import { DomSanitizer } from "@angular/platform-browser";
import { TranslateService } from "@ngx-translate/core";
import { filter, take } from "rxjs/operators";
import { AngularFireAuth } from "@angular/fire/compat/auth";
import { AngularFirestore } from "@angular/fire/compat/firestore";
import { AddEditSkillComponent } from "../../../modals/add-edit-skill/add-edit-skill.component";

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: "myp-account-skills",
  templateUrl: "./skills.component.html",
  standalone: false,
})
export class SkillsComponent extends BaseComponent implements OnInit {
  public availableSkills: Array<any>;
  public mySkills: Array<any> = [];
  public loading: boolean;
  public interests: Array<any> = [];
  constructor(
    public userService: UserService,
    public helperService: HelperService,
    private _win: WindowService,
    private _router: Router,
    private _route: ActivatedRoute,
    public appService: AppService,
    private _sanitizer: DomSanitizer,
    private _translate: TranslateService,
    public fbAuth: AngularFireAuth,
    public db: AngularFirestore,
    public router: Router,
    public communityService: WebCommunityService,
    private avoService: AvoService
  ) {
    super(userService);
  }

  ngOnInit() {
    this.loadMySkills();
  }

  public skillsByType: { [type: string]: Array<any> } = {};

  loadMySkills() {
    this.loading = true;
    this.skillsByType = {};
    this.communityService.getUserSkills(false, true).subscribe((result) => {
      this.loading = false;
      this.mySkills = result;
      this.mySkills.forEach((skill) => {
        if (!this.skillsByType[skill.type]) {
          this.skillsByType[skill.type] = [];
        }
        this.skillsByType[skill.type].push(skill);
      });
    });
  }

  addSkill() {
    // Fire CTA Clicked for Skills & Interests (only in My Fender)
    if (this.userService.appId === "fender") {
      this.avoService.avoInitted$
        .pipe(
          filter((v) => !!v),
          take(1)
        )
        .subscribe(() => {
          const te = this.avoService.trackEvent();
          if (te && typeof (te as any).ctaClicked === "function") {
            const page = this.avoService.getPageProperties({ pageName: "Skills & Interests" });
            const extra: Record<string, any> = {
              ctaText: this.mySkills && this.mySkills.length ? "Add More Skills" : "Add Skills",
              ctaLocation: "Skills & Interests",
              utmId: (page as any).utmId ?? 0,
              utmTerm: (page as any).utmTerm ?? "",
            };
            const payload = this.avoService.buildEventPayload<Record<string, any>>(page, extra, { omitNulls: true });
            (te as any).ctaClicked(payload);
          }
        });
    }
    const modalRef = this.appService.showModal(AddEditSkillComponent, { size: "lg" });
    modalRef.componentInstance.skillAdded.pipe(take(1)).subscribe((result) => {
      this.loadMySkills();
    });
  }
}
